/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelSubscriptionDto } from '../models/CancelSubscriptionDto';
import type { CheckoutSessionDto } from '../models/CheckoutSessionDto';
import type { CreateBasicSubscriptionSessionDto } from '../models/CreateBasicSubscriptionSessionDto';
import type { CreatePrivatePatientSessionDto } from '../models/CreatePrivatePatientSessionDto';
import type { PaymentDto } from '../models/PaymentDto';
import type { SessionStatusDto } from '../models/SessionStatusDto';
import type { SubscriptionStatusDto } from '../models/SubscriptionStatusDto';
import type { UpdateBasicSubscriptionSessionDto } from '../models/UpdateBasicSubscriptionSessionDto';
import type { UpdatePrivatePatientSessionDto } from '../models/UpdatePrivatePatientSessionDto';
import type { UpdateSessionBodyDto } from '../models/UpdateSessionBodyDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class PaymentService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Create one-time Stripe checkout session for a private patient (Webflow embed)
     * @param requestBody
     * @returns CheckoutSessionDto
     * @throws ApiError
     */
    public createPrivatePatientSession(
        requestBody: CreatePrivatePatientSessionDto,
    ): CancelablePromise<CheckoutSessionDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/payment/self-paid-session',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Update private patient Stripe session metadata before payment confirmation
     * @param id
     * @param requestBody
     * @returns CheckoutSessionDto
     * @throws ApiError
     */
    public updatePrivatePatientSession(
        id: string,
        requestBody: UpdatePrivatePatientSessionDto,
    ): CancelablePromise<CheckoutSessionDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/payment/self-paid-session/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Get self-paid Stripe session status (used after redirect-based payment methods)
     * @param id
     * @returns SessionStatusDto
     * @throws ApiError
     */
    public getSelfPaidSessionStatus(
        id: string,
    ): CancelablePromise<SessionStatusDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/payment/self-paid-session/{id}/status',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Create Stripe subscription checkout session for the 59kr Basic plan (Webflow embed)
     * @param requestBody
     * @returns CheckoutSessionDto
     * @throws ApiError
     */
    public createBasicSubscriptionSession(
        requestBody: CreateBasicSubscriptionSessionDto,
    ): CancelablePromise<CheckoutSessionDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/payment/basic-subscription-session',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Update Basic subscription Stripe session metadata before payment confirmation
     * @param id
     * @param requestBody
     * @returns CheckoutSessionDto
     * @throws ApiError
     */
    public updateBasicSubscriptionSession(
        id: string,
        requestBody: UpdateBasicSubscriptionSessionDto,
    ): CancelablePromise<CheckoutSessionDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/payment/basic-subscription-session/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Get Basic subscription Stripe session status (used after redirect-based payment methods)
     * @param id
     * @returns SessionStatusDto
     * @throws ApiError
     */
    public getBasicSubscriptionSessionStatus(
        id: string,
    ): CancelablePromise<SessionStatusDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/payment/basic-subscription-session/{id}/status',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Update Stripe checkout session metadata with personal number
     * @param id
     * @param requestBody
     * @returns CheckoutSessionDto
     * @throws ApiError
     */
    public updateSession(
        id: string,
        requestBody: UpdateSessionBodyDto,
    ): CancelablePromise<CheckoutSessionDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/payment/session/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Delete Stripe subscription
     * @param id
     * @returns boolean
     * @throws ApiError
     */
    public deleteSubscription(
        id: string,
    ): CancelablePromise<boolean> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/payment/subscription/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Get the authenticated user's active Basic subscription, if any
     * @returns SubscriptionStatusDto
     * @throws ApiError
     */
    public getMySubscription(): CancelablePromise<SubscriptionStatusDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/payment/subscription',
        });
    }

    /**
     * Cancel the authenticated user's active Basic subscription at the end of the current billing period
     * @returns CancelSubscriptionDto
     * @throws ApiError
     */
    public cancelMySubscription(): CancelablePromise<CancelSubscriptionDto> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/payment/subscription',
        });
    }

    /**
     * Stripe webhook
     * @returns any
     * @throws ApiError
     */
    public listenWebhook(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/payment/webhook',
        });
    }

    /**
     * Get all payments
     * @returns PaymentDto
     * @throws ApiError
     */
    public getAllPayments(): CancelablePromise<Array<PaymentDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/payment',
        });
    }

    /**
     * Get all free card payments
     * @returns PaymentDto
     * @throws ApiError
     */
    public getAllFreeCardPayments(): CancelablePromise<Array<PaymentDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/payment/free-card',
        });
    }

}
